import React, { Fragment, useState, useEffect } from "react";
import { notification, Button, Col, Row, Input, Switch, Select as SelectAntd, message, Select, Upload, Popover, Spin, DatePicker } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
  VEHICLE_SUB_CATEGORY,
  VIHCLE_CATEGORY_SPECIALIZED,
  VIHCLE_CATEGORY_PICKUP,
  VIHCLE_CATEGORY_MOOC,
  VIHCLE_CATEGORY_GROUP,
  VEHICLE_SUB_TYPE,
  PLATE_COLOR,
  VIHCLE_CATEGORY_OTO,
  VIHCLE_CATEGORY_BUS,
  VIHCLE_CATEGORY_TRUCK,
} from "constants/scheduleStatus";
import { PARTNER_STATION_TYPE_OPTIONS } from "constants/station";
import useCommonData from "hooks/CommonData";
import { CopyOutlined, DownloadOutlined } from "@ant-design/icons";
import InspectionProcessService from "./../../services/inspectionProcessService";
import { useLocation } from "react-router-dom";
import "./setting.scss";
import { filter } from "lodash";
import BasicButtonPrimary from "components/BasicButtonPrimary";
import AddreditationSettingService from "services/AccreditationSettingService";
import uploadService from "services/uploadService";
import TextEditor from "components/TextEditor";
import ColorPicker from 'react-best-gradient-color-picker'
import { useQrBooking } from "./_components/QrBooking/hook";

const CONFIRM_BOOKING_SCHEDULE_TERM_READONLY_LOCK = "miniapp-confirm-booking-schedule-term-readonly";

const MiniApp = () => {
  const { t: translation } = useTranslation();
  const location = useLocation();
  const searchparam = location.search;
  const params = new URLSearchParams(searchparam);
  const confirmBookingScheduleTermEditorRef = React.useRef(null);
  const [vehicleSubCategoryOptions, setVehicleSubCategoryOptions] =
    useState(VIHCLE_CATEGORY_OTO);
  const { metaData } = useCommonData();
  const { 
    loading: loadingQr,
    listImage: qrImages,       
    handleDownload: downloadQr,
    getQrCode
  } = useQrBooking();
  const newType = Object.values(metaData?.SCHEDULE_TYPE || {}).filter((el) => el?.scheduleType && el?.scheduleTypeName).map((el) => {
    return {
      ...el,
      label: el.scheduleTypeName,
      value: el.scheduleType,
    };
  });
  const stationTypeOptions = PARTNER_STATION_TYPE_OPTIONS;
  const defaultStationType =
    stationTypeOptions.find((item) => `${item?.label || ""}`.toLowerCase().includes("trung tâm đăng kiểm"))?.value ??
    stationTypeOptions?.[0]?.value ??
    0;
  const [settingData, setSettingData] = useState({});
  const [area, setArea] = useState([]);
  const [station, setStation] = useState([])
  // const [hiddens, setHiddens] = useState(true)
  const [data, setData] = useState({
    partner: null,
    stationArea: null,
    stationType: defaultStationType,
    stationsCode: null,
    visible_StationArea: true,
    visible_StationType: false,
    visible_StationsCode: true,
    scheduleType: 1,
    visible_scheduleType: true,
    dateSchedule: null,
    time: null,
    firstName: null,
    phoneNumber: null,
    vehicleIdentity: null,
    vehiclePlateColor: PLATE_COLOR?.[0]?.value || 1,
    vehicleSubCategory: 1001,
    vehicleSubType: 1,
    certificateSeries: '',
    visible_firstName: false,
    visible_phoneNumber: false,
    visible_vehicleIdentity: false,
    visible_vehicleType: null,
    visible_vehiclePlateColor: true,
    visible_vehicleSubCategory: false,
    visible_vehicleSubType: false,
    visible_certificateSeries: true,
    visible_dateSchedule: true,
    visible_timeSchedule: true,
    visible_stationService: false,
    require_firstName: true,
    require_StationArea: true,
    require_StationType: false,
    require_StationsCode: true,
    require_scheduleType: true,
    require_dateSchedule: true,
    require_timeSchedule: true,
    require_phoneNumber: true,
    require_vehicleIdentity: true,
    require_vehicleType: null,
    require_vehiclePlateColor: true,
    require_vehicleSubCategory: false,
    require_vehicleSubType: true,
    require_certificateSeries: false,
    require_stationService: false,
    stationsId: null,
    partnerBackground: [],
    partnerColorButton: "",
    partnerColorGradient: "",
    partnerColorTitle: "",
    partnerFormTitle: "",
    confirmBookingScheduleEnabled: false,
    confirmBookingScheduleUrl: "",
    confirmBookingScheduleTerm: "",
  });

  const handleOnchange = (name, value) => {
    if(name === 'vntId'){
      const obj = area?.filter(el => el.value === value)
      fetchDataStation(obj[0]?.label, "", data?.stationType)
    }
    if(name === 'stationType'){
      const selectedArea = area?.find(el => el.value === data?.vntId)
      fetchDataStation(selectedArea?.label, "", value)
    }
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCategory = (evt) => {
    if(evt === undefined){
      return []
    }
    const categoryOptionsMap = {
      [VEHICLE_SUB_CATEGORY.CAR]: VIHCLE_CATEGORY_OTO,
      [VEHICLE_SUB_CATEGORY.PASSENGER]: VIHCLE_CATEGORY_BUS,
      [VEHICLE_SUB_CATEGORY.TRUCKER]: VIHCLE_CATEGORY_TRUCK,
      [VEHICLE_SUB_CATEGORY.GROUP]: VIHCLE_CATEGORY_GROUP,
      [VEHICLE_SUB_CATEGORY.ROMOOCL]: VIHCLE_CATEGORY_MOOC,
      [VEHICLE_SUB_CATEGORY.CAR_SPECIALIZED]: VIHCLE_CATEGORY_PICKUP,
      [VEHICLE_SUB_CATEGORY.ORTHER]: VIHCLE_CATEGORY_SPECIALIZED,
    };

    const options = categoryOptionsMap[evt] || [];
    setVehicleSubCategoryOptions(options);
    return options;
  };

  function handleCopyItem(value) {
    navigator.clipboard.writeText(value);
    message.success(translation("setting.copied"));
  }

  const normalizeRichTextValue = (value = "") => {
    if (!value) {
      return "";
    }

    const container = document.createElement("div");
    container.innerHTML = value;

    const plainText = (container.textContent || container.innerText || "")
      .replace(/[\u00A0\u200B-\u200D\uFEFF]/g, " ")
      .trim();

    const hasMediaContent = !!container.querySelector("img, video, audio, iframe, table, embed, object");

    return plainText || hasMediaContent ? value : "";
  };

  const getConfirmBookingScheduleTermValue = () => {
    const editor = confirmBookingScheduleTermEditorRef.current;
    const stateValue = normalizeRichTextValue(data.confirmBookingScheduleTerm);

    if (editor) {
      const editorValue = normalizeRichTextValue(editor.getData());
      return editorValue || stateValue;
    }

    return stateValue;
  };

  const fetchData = async () => {
    const result = await InspectionProcessService.getApikey({});
    if (result) {
      setSettingData(result.data.data);
    }
  };

  const fetchDataArea = async () => {
    const result = await InspectionProcessService.getAllStationArea({});
    if (result) {
      const newArr = result.data.map((el) => {
        return {
          label: el.value,
          value: el.value,
        };
      });
      setArea(newArr);
      const getMiniAppDefault = JSON.parse(localStorage.getItem("MiniAppDefault")) || data
      // setData(getMiniAppDefault)
      fetchDataStation(getMiniAppDefault.vntId, "", getMiniAppDefault.stationType ?? defaultStationType)
      handleCategory(getMiniAppDefault.vehicleSubType)
    }
  };

  const fetchDataStation = async (label, searchText = "", stationType = data?.stationType) => {
    const normalizedStationType =
      stationType === undefined || stationType === null || stationType === "" ? undefined : Number(stationType);
    const param = searchText
      ? { searchText: searchText.trim() }
      : {
          filter: {
            stationArea: label,
            ...(normalizedStationType !== undefined ? { stationType: normalizedStationType } : {})
          }
        }
    const result = await InspectionProcessService.getAllExternal(param);
    if (result) {
      const newArr = result?.data?.data?.map((el) => {
        return {
          label: el.stationCode,
          value: el.stationsId,
        };
      });
      setStation([{ label: "Tất cả", value: null }, ...(newArr || [])]);
    }
    // setHiddens(false)
  };

  const fetchConfigMiniApp = async () => {
    AddreditationSettingService.findById({})
    .then((result) => {
      const {issSuccess, statusCode, data} = result
      if(issSuccess && statusCode === 200){
        const stationMiniAppConfig = JSON.parse(data.stationMiniAppLink)
        setData((prev) => ({
          ...prev,
          ...stationMiniAppConfig,
          stationType: stationMiniAppConfig?.stationType ?? prev.stationType ?? defaultStationType,
        }));
      }
    })
    .catch((err) => {
      notification['error']({
        message: "",
        description: 'Có lỗi xảy ra khi lấy cấu hình Mini App'
      })
    })
    .finally(() => {});
  }

  useEffect(() => {
    fetchData();
    fetchDataArea();
    fetchConfigMiniApp()
  }, []);

  useEffect(() => {
    const editor = confirmBookingScheduleTermEditorRef.current;

    if (!editor) {
      return;
    }

    if (data.confirmBookingScheduleEnabled) {
      editor.disableReadOnlyMode(CONFIRM_BOOKING_SCHEDULE_TERM_READONLY_LOCK);
      return;
    }

    editor.enableReadOnlyMode(CONFIRM_BOOKING_SCHEDULE_TERM_READONLY_LOCK);
  }, [data.confirmBookingScheduleEnabled]);

  let param = settingData?.[0]?.apiKey ? `${process.env.REACT_APP_WEB_PARTNER_URL || "https://partner.ttdk.com.vn"}/booking?apikey=${settingData?.[0]?.apiKey}` : undefined;
  // Object.entries(data).forEach(([key, value]) => (param += `&${key}=${value}`));
  let paramIfram = param ? `<iframe src=${param} width={500} height={600} style={{ border: "1px solid" }} />` : undefined;

  const handleSave = () =>{
    // localStorage.setItem("MiniAppDefault" , JSON.stringify(data))
    const confirmBookingScheduleUrl = data.confirmBookingScheduleUrl?.trim() || "";
    const confirmBookingScheduleTerm = getConfirmBookingScheduleTermValue();

    if (data.confirmBookingScheduleEnabled && !confirmBookingScheduleTerm) {
      notification['error']({
        message: "",
        description: "Khi bật điều hướng lịch hẹn, vui lòng nhập Điều khoản chia sẻ dữ liệu."
      })
      return;
    }

    const payload = {
      ...data,
      confirmBookingScheduleUrl,
      confirmBookingScheduleTerm,
      require_phoneNumber: true,
      require_vehicleIdentity: true,
    };

    const dataString = JSON.stringify(payload)
    AddreditationSettingService.updateById({data: { stationMiniAppLink: dataString}})
    .then((result) => {
      const {issSuccess, statusCode} = result
      if(issSuccess && statusCode === 200){
        notification['success']({
          message: "",
          description: translation("customerSettings.updateSettingsSuccess")
        })
      }
    })
    .catch((err) => {
      notification['error']({
        message: "",
        description: translation("customerSettings.updateSettingsError")
      })
    })
  }

  const [isLoadingUploadImg, setIsLoadingUploadImg] = useState(false)
  const uploadToServer = async (file) => {
    if (!file) return undefined
    const reader = new FileReader()
    return new Promise((resolve, reject) => {
      reader.onload = async function () {
        const baseString = reader.result
        const params = {
          imageData: baseString.replace('data:' + file.type + ';base64,', ''),
          imageFormat: file.type.replace('image/', '')
        }

        try {
          setIsLoadingUploadImg(true)
          const res = await uploadService.uploadImage(params)
          setIsLoadingUploadImg(false)
          const img = res?.data
          resolve(img)
        } catch (error) {
          setIsLoadingUploadImg(false)
          reject(undefined)
        }
      }

      reader.onerror = function (error) {
        reject(undefined)
      }

      reader.readAsDataURL(file)
    })
  }

  const [isOpenPopover, setIsOpenPopover] = useState({
    partnerColorButton: false,
    partnerColorGradient: false,
    partnerColorTitle: false
  })

  const ButtonClearColor = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        style={{
          width: 32,
          height: 32,
          minWidth: 32,
          border: "1px solid #ff4d4f",
          backgroundColor: "#fff",
          color: "#ff4d4f",
          fontSize: 18,
          fontWeight: "bold",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
        }}
        aria-label="Clear"
      >
        ✕
      </button>
    )
  }
  
  return (
    <Fragment>
      <Row className="miniapp-layout" gutter={[16, 16]}>
        <Col lg={18} md={24} sm={24} xs={24}>
          <Row className="miniapp-columns">
        <Col lg={8} md={12} sm={12} xs={24}>
          <h6>{translation("setting.display_value")}</h6>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>{translation("setting.area")}</div>
            </Col>
            <Col span={10}>
              <SelectAntd
                onChange={(e) => {
                  handleOnchange("vntId", e);
                }}
                options={area}
                defaultValue={data.stationArea}
                className="w-100"
                placeholder="Khu vực"
                value={area.find(el => el.label === data.vntId)}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>Loại trung tâm</div>
            </Col>
            <Col span={10}>
              <SelectAntd
                onChange={(e) => {
                  handleOnchange("stationType", e);
                }}
                options={stationTypeOptions}
                className="w-100"
                placeholder="Loại trung tâm"
                value={data.stationType}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>{translation("landing.stationCode")}</div>
            </Col>
            <Col span={10}>
              <Input
                onChange={(e) => handleOnchange("stationsCode", e.target.value)}
                className="w-100"
                placeholder="Mã trạm"
                value={data.stationsCode || ""}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>{translation("management.fullName")}</div>
            </Col>
            <Col span={10}>
              <Input onChange={(e) => handleOnchange("name", e.target.value)} value={data.name}/>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>{translation("listSchedules.phoneNumber")}</div>
            </Col>
            <Col span={10}>
              <Input
                onChange={(e) => handleOnchange("phone", e.target.value)}
                value={data.phone}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>{translation("landing.appointment_purpose")}</div>
            </Col>
            <Col span={10}>
              <SelectAntd
                onChange={(e) => {
                  handleOnchange("scheduleType", e);
                }}
                options={newType}
                defaultValue={data.scheduleType}
                className="w-100"
                value={newType.find(el => el.scheduleType === data.scheduleType)}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>Dịch vụ</div>
            </Col>
            <Col span={10}>
              <Input disabled/>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>{translation("landing.license-plates")}</div>
            </Col>
            <Col span={10}>
              <Input
                onChange={(e) =>
                  handleOnchange("licensePlates", e.target.value)
                }
                value={data.licensePlates}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>{translation("accreditation.licensePlateColorLabel")}</div>
            </Col>
            <Col span={10}>
              <SelectAntd
                onChange={(e) => handleOnchange("licensePlateColor", e)}
                options={PLATE_COLOR}
                className="w-100"
                value={PLATE_COLOR.find(el => el.value === data.licensePlateColor)}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>{translation("landing.transportation")}</div>
            </Col>
            <Col span={10}>
              <SelectAntd
                onChange={(e, vehicleType) => {
                  const categoryOptions = handleCategory(e);
                  setData((prev) => {
                    const isCurrentCategoryValid = categoryOptions.some(
                      (option) => String(option.value) === String(prev.vehicleSubCategory)
                    );
                    return {
                    ...prev,
                    vehicleType: vehicleType.vehicleType,
                    vehicleSubType: e,
                    vehicleSubCategory: isCurrentCategoryValid
                      ? prev.vehicleSubCategory
                      : categoryOptions?.[0]?.value,
                    };
                  });
                }}
                options={VEHICLE_SUB_TYPE}
                defaultValue={VEHICLE_SUB_TYPE[0]}
                className="w-100"
                value={VEHICLE_SUB_TYPE.find(el => el.value === data.vehicleSubType)}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>{translation("landing.classify")}</div>
            </Col>
            <Col span={10}>
              <SelectAntd
                onChange={(e) => {
                  handleOnchange("vehicleSubCategory", e);
                }}
                value={
                  vehicleSubCategoryOptions.find((opt) => String(opt.value) === String(data.vehicleSubCategory))?.value ??
                  data.vehicleSubCategory
                }
                options={vehicleSubCategoryOptions}
                className="w-100"
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>{translation("landing.code_gcn")}</div>
            </Col>
            <Col span={10}>
              <Input
                onChange={(e) =>
                  handleOnchange("certificateSeries", e.target.value)
                }
                value={data.certificateSeries}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>Ngày bắt đầu</div>
            </Col>
            <Col span={10}>
              <DatePicker
                format="DD/MM/YYYY"
                className="w-100"
                placeholder="DD/MM/YYYY"
                value={data.dateSchedule ? moment(data.dateSchedule, "DD/MM/YYYY") : null}
                onChange={(date) => handleOnchange("dateSchedule", date ? date.format("DD/MM/YYYY") : null)}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={10}>
              <div>Giờ hẹn</div>
            </Col>
            <Col span={10}>
              <Input
                disabled
                value={data.time}
              />
            </Col>
          </Row>
        </Col>
        <Col lg={8} md={12} sm={12} xs={24}>
          <h6>{translation("sms.show")}</h6>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.show_area")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_StationArea === true ? true : false}
                onChange={(checked) => {
                  handleOnchange("visible_StationArea", checked);
                }}
                value={data.visible_StationArea}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>Loại trung tâm</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_StationType === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_StationType", checked)
                }
                value={data.visible_StationType}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.show_code")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_StationsCode === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_StationsCode", checked)
                }
                value={data.visible_StationsCode}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.show_fullname")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_firstName === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_firstName", checked)
                }
                value={data.visible_firstName}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.show_phone")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_phoneNumber === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_phoneNumber", checked)
                }
                value={data.visible_phoneNumber}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("landing.appointment_purpose")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_scheduleType === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_scheduleType", checked)
                }
                value={data.visible_scheduleType}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>Dịch vụ</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_stationService === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_stationService", checked)
                }
                value={data.visible_stationService}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.show_bsx")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_vehicleIdentity === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_vehicleIdentity", checked)
                }
                value={data.visible_vehicleIdentity}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.show_colorPlate")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_vehiclePlateColor === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_vehiclePlateColor", checked)
                }
                value={data.visible_vehiclePlateColor}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.show_transportation")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_vehicleSubType === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_vehicleSubType", checked)
                }
                value={data.visible_vehicleSubType}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.show_classify")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={
                  data.visible_vehicleSubCategory === true ? true : false
                }
                onChange={(checked) =>
                  handleOnchange("visible_vehicleSubCategory", checked)
                }
                value={data.visible_vehicleSubCategory}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.show_gcn")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_certificateSeries === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_certificateSeries", checked)
                }
                value={data.visible_certificateSeries}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>Ngày hẹn</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_dateSchedule === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_dateSchedule", checked)
                }
                value={data.visible_dateSchedule}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>Giờ hẹn</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.visible_timeSchedule === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("visible_timeSchedule", checked)
                }
                value={data.visible_timeSchedule}
              />
            </Col>
          </Row>
        </Col>
        <Col lg={8} md={12} sm={12} xs={24}>
          <h6>{translation("setting.required_field")}</h6>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.show_area")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_StationArea === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_StationArea", checked)
                }
                value={data.require_StationArea}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>Loại trung tâm</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_StationType === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_StationType", checked)
                }
                value={data.require_StationType}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.show_code")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_StationsCode === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_StationsCode", checked)
                }
                value={data.require_StationsCode}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.require_fullname")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_firstName === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_firstName", checked)
                }
                value={data.require_firstName}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.require_phone")}</div>
            </Col>
            <Col span={7}>
              <Switch
                disabled
                checked={true}
                onChange={() =>
                  handleOnchange("require_phoneNumber", true)
                }
                value={data.require_phoneNumber}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("landing.appointment_purpose")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_scheduleType === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_scheduleType", checked)
                }
                value={data.require_scheduleType}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>Dịch vụ</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_stationService === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_stationService", checked)
                }
                value={data.require_stationService}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.require_bsx")}</div>
            </Col>
            <Col span={7}>
              <Switch
                disabled
                checked={true}
                onChange={() =>
                  handleOnchange("require_vehicleIdentity", true)
                }
                value={data.require_vehicleIdentity}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.require_colorPlate")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_vehiclePlateColor === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_vehiclePlateColor", checked)
                }
                value={data.require_vehiclePlateColor}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.require_transportation")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_vehicleSubType === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_vehicleSubType", checked)
                }
                value={data.require_vehicleSubType}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.require_classify")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_vehicleSubCategory === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_vehicleSubCategory", checked)
                }
                value={data.require_vehicleSubCategory}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>{translation("setting.require_gcn")}</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_certificateSeries === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_certificateSeries", checked)
                }
                value={data.require_certificateSeries}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>Ngày hẹn</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_dateSchedule === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_dateSchedule", checked)
                }
                value={data.require_dateSchedule}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3 smsrow">
            <Col span={15}>
              <div>Giờ hẹn</div>
            </Col>
            <Col span={7}>
              <Switch
                checked={data.require_timeSchedule === true ? true : false}
                onChange={(checked) =>
                  handleOnchange("require_timeSchedule", checked)
                }
                value={data.require_timeSchedule}
              />
            </Col>
          </Row>
        </Col>
        <Col lg={8} md={12} sm={12} xs={24}>
            <h6>Giao diện hiển thị</h6>
            <Row gutter={[16, 16]} className="mt-3">
              <Col span={10}>
                <div>{"Tiêu đề mẫu đặt lịch"}</div>
              </Col>
              <Col span={10}>
                <Input
                  onChange={(e) => handleOnchange("partnerFormTitle", e.target.value)}
                  placeholder="Tiêu đề mẫu đặt lịch"
                  value={data.partnerFormTitle}
                />
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="mt-3">
              <Col span={10}>
                <div>{translation("setting.logo_partner")}</div>
              </Col>
              <Col span={10}>
                <Input
                  onChange={(e) => handleOnchange("partner", e.target.value)}
                  placeholder="Logo url"
                  value={data.partner}
                />
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="mt-3">
              <Col span={10}>
                <div>Background Partner</div>
              </Col>
              <Col span={10}>
                <Upload
                  disabled={isLoadingUploadImg}
                  motion={false}
                  name={"uploadBanner"}
                  listType="picture-card"
                  multiple={false}
                  maxCount={1}
                  accept="image/*"
                  beforeUpload={async (file) => {
                    if (!file) return false
                    const imgUrl = await uploadToServer(file)
                    if (!imgUrl) return false
                    const newData = [...(data.partnerBackground || []), { url: imgUrl }]
                    handleOnchange("partnerBackground", newData)
                    return false
                  }}
                  fileList={data.partnerBackground || []}
                  onRemove={(file) => {
                    const newData = data.partnerBackground?.filter((item) => item?.url !== file.url)
                    handleOnchange("partnerBackground", newData)
                  }}>
                  {data.partnerBackground?.length >= 1 ? null : `+ Tải lên`}
                </Upload>
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="mt-3">
              <Col span={10}>
                <div>Màu sắc title</div>
              </Col>
              <Col span={10} className="d-flex gap-2">
                <Popover
                  content={              
                    <ColorPicker 
                      value={data.partnerColorTitle} 
                      onChange={(e) => handleOnchange("partnerColorTitle", e)} 
                      hideGradientType={true}
                      hideGradientControls ={true}
                      hideGradientAngle={true}
                      hideGradientStops={true}
                      hideControls={true}
                    />
                  }
                  title="Title"
                  trigger="click"
                  open={isOpenPopover.partnerColorTitle}
                  onOpenChange={(value) => setIsOpenPopover({ ...isOpenPopover, partnerColorTitle: value })}
                >
                  <Button type="primary">Màu</Button>
                </Popover>
                <div className="d-flex align-items-center gap-2"> 
                  <div style={{width: 20, height: 32, minWidth: 32, background: data.partnerColorTitle, border: "1px solid #ccc"}}></div>
                  <ButtonClearColor onClick={() => handleOnchange("partnerColorTitle", "")} />
                </div>
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="mt-3">
              <Col span={10}>
                <div>Màu sắc nút xác nhận</div>
              </Col>
              <Col span={10} className="d-flex gap-2">
                <Popover
                  content={              
                    <ColorPicker value={data.partnerColorButton} onChange={(e) => handleOnchange("partnerColorButton", e)}/>
                  }
                  title="Title"
                  trigger="click"
                  open={isOpenPopover.partnerColorButton}
                  onOpenChange={(value) => setIsOpenPopover({ ...isOpenPopover, partnerColorButton: value })}
                >
                  <Button type="primary">Màu</Button>
                </Popover>
                <div className="d-flex align-items-center gap-2"> 
                  <div style={{width: 20, height: 32, minWidth: 32, background: data.partnerColorButton, border: "1px solid #ccc"}}></div>
                  <ButtonClearColor onClick={() => handleOnchange("partnerColorButton", "")} />
                </div>
              </Col>
            </Row>
             <Row gutter={[16, 16]} className="mt-3">
              <Col span={10}>
                <div>Màu sắc Active</div>
              </Col>
              <Col span={10} className="d-flex gap-2">
                <Popover
                  content={              
                    <ColorPicker value={data.partnerColorGradient} onChange={(e) => handleOnchange("partnerColorGradient", e)}/>
                  }
                  title="Title"
                  trigger="click"
                  open={isOpenPopover.partnerColorGradient}
                  onOpenChange={(value) => setIsOpenPopover({ ...isOpenPopover, partnerColorGradient: value })}
                >
                  <Button type="primary">Màu</Button>
                </Popover>
                <div className="d-flex align-items-center gap-2"> 
                  <div style={{width: 20, height: 32, minWidth: 32, background: data.partnerColorGradient, border: "1px solid #ccc"}}></div>
                  <ButtonClearColor onClick={() => handleOnchange("partnerColorGradient", "")} />
                </div>
              </Col>
            </Row>
        </Col>
        <Col lg={16} md={12} sm={12} xs={24}>
            <h6>Điều hướng lịch hẹn</h6>
            <Row gutter={[16, 16]} className="mt-3">
              <Col lg={8} md={9}>
                <div>Cho phép điều hướng</div>
              </Col>
              <Col lg={16} md={15}>
                <Switch
                  checked={data?.confirmBookingScheduleEnabled === true ? true : false}
                  onChange={(checked) =>
                    handleOnchange("confirmBookingScheduleEnabled", checked)
                  }
                  value={data?.confirmBookingScheduleEnabled}
                />
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="mt-3">
              <Col md={9} lg={8}>
                <div>Đường dẫn điều hướng</div>
              </Col>
              <Col md={12} lg={14}>
                <Input
                  disabled={!data?.confirmBookingScheduleEnabled}
                  onChange={(e) =>
                    handleOnchange("confirmBookingScheduleUrl", e.target.value)
                  }
                  value={data?.confirmBookingScheduleUrl}
                />
              </Col>
            </Row>
            <div className="mt-3">Điều khoản chia sẻ dữ liệu</div>
            <Row gutter={[16, 16]} className="mt-1">
              <Col span={24}>
                <div className="miniapp-textEditor miniapp-textEditor--confirmBookingScheduleTerm">
                  <style>
                    {`
                      .miniapp-textEditor--confirmBookingScheduleTerm .ck.ck-editor__main > .ck-editor__editable {
                        min-height: 150px;
                        height: 150px;
                        max-height: 150px;
                        overflow-y: auto;
                      }
                    `}
                  </style>
                  <TextEditor
                    config={{
                      language: "vi",
                      placeholder: "Nhập điều khoản chia sẻ dữ liệu",
                    }}
                    data={data?.confirmBookingScheduleTerm || ""}
                    onChange={(__, editor) => {
                      handleOnchange("confirmBookingScheduleTerm", editor.getData())
                    }}
                    onReady={(editor) => {
                      confirmBookingScheduleTermEditorRef.current = editor;

                      if (!data?.confirmBookingScheduleEnabled) {
                        editor.enableReadOnlyMode(CONFIRM_BOOKING_SCHEDULE_TERM_READONLY_LOCK);
                      }
                    }}
                  />
                </div>
              </Col>
            </Row>
        </Col>
        </Row>
        </Col>
        <Col lg={6} md={24} sm={24} xs={24} className="miniapp-preview-column">
          <div className="miniapp-preview-wrapper">
          <h6>{translation("setting.preview")}</h6>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={8}>
              <div>{translation("setting.path_miniApp")}</div>
            </Col>
            <Col span={14}>
              <Input value={param} disabled />
            </Col>
            <Col span={2}>
              <CopyOutlined
                style={{ fontSize: 20, cursor: "pointer" }}
                onClick={() => param && handleCopyItem(param)}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <Col span={8}>
              <div>{translation("setting.integrated_code")}</div>
            </Col>
            <Col span={14}>
              <Input value={paramIfram} disabled />
            </Col>
            <Col span={2}>
              <CopyOutlined
                style={{ fontSize: 20, cursor: "pointer" }}
                onClick={() => paramIfram && handleCopyItem(paramIfram)}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt-3">
            <iframe
              src={param}
              width={500}
              height={600}
              style={{ border: "1px solid" }}
            />
          </Row>
          </div>
        </Col>
      </Row>
        <Row className="d-flex justify-content-center gap-3">
          {/* <Button type="primary" onClick={() => handleSave()} className="mt-3">
              {translation('setting.bankTransferModal.saveButton')}
          </Button> */}
          <BasicButtonPrimary
            onclick={() => handleSave()} className="mt-3"
            text={translation('setting.bankTransferModal.saveButton')}
          />
          {
            qrImages.length > 0 && (
              qrImages.map((item) => (
                <BasicButtonPrimary
                  className="d-flex align-items-center justify-content-center mt-3"
                  loading={loadingQr}
                  icon={<DownloadOutlined />}
                  onclick={async() => {
                    if (!item?.url) {
                      const newImages = await getQrCode();
                      const imageUrl = newImages?.[item?.key];
                      downloadQr({
                        ...item,
                        url: imageUrl
                      })
                    }else{
                      downloadQr(item)
                    }
                  }}
                  text={item?.textDownload}
                />  
              ))
            )
          }
        </Row>
    </Fragment>
  );
};

export default MiniApp;
